import React, { Component } from 'react';
import CheckAuth from '../../../utils/hoc/CheckAuth';
import CardProfil from '../../organism/profil/CardProfil';
import CardData from '../../organism/profil/CardData';
import ProfilAction from '../../../redux/actions/Profil'
import { connect } from 'react-redux';
import Loading from '../../../components/molecules/Loading';
import { get_user_parameters } from '../../../config/api'
import GetParameter from '../../../utils/actions/GetParameter';
import { SET_ERROR_STATE } from '../../../utils/constants/actionTypes'


class Profil extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      statusBtn : [
        { title : 'Data Diri', status : true, key : 'DataDiri' }, 
				{ title : 'Data Perusahaan', status : false, key : 'DataPerusahaan' }, 
				{ title : 'Dokumen Perusahaan', status : false, key : 'DokumenPerusahaan' }, 
				{ title : 'Data Rekening', status : false, key : 'DataRekening' }, 
				{ title : 'Data Keuangan', status : false, key : 'DataKeuangan' }
      ],
    };
  }
  componentDidMount = () => {
		const {RefreshToken, GetProfile, ClientID} = this.props;

    this.props.setTitlePage({
			title : 'Profil Saya',
			breadcrumb : [
				{name : 'Beranda', url : '/dashboard', status : false},
				{name : 'Profil Saya', url : '/#', status : true},
			]
    })
    if(ClientID){
      // console.log('====================================');
      // console.log("masuk prof === ", ClientID);
      // console.log('====================================');
      // GetListLoan(ClientID)
      GetProfile(ClientID)
      this.getParameter()
    }
  }
  getParameter = () => {
    let {SetError} = this.props
    GetParameter(get_user_parameters, null, (params, errMsg) => {
      if(errMsg){
        SetError(errMsg)
      } else{
        // console.log("param berhasil === ", params.parameters);
        this.setState({ params : params.parameters })
      }
    })
  }
  setFromParam = (key, value) => {
    let {params} = this.state
    if(params){
      const result = params[key].find(function(element) {
        return element.paramValue === value
      });
      // console.log("nyari param yang cocok --- ",{ key, value, result});
      return result ? result.paramName : '-'
    }
    
  }
  changeBtn = (index) => {
		let { statusBtn } = this.state
		for( let i = 0; i < statusBtn.length; i++ ){
			if( i === index ){
				statusBtn[i].status = true
			} else{
				statusBtn[i].status = false
			}
		}
		this.setState({ statusBtn })
	}
  render() {
    let { statusBtn } = this.state
		const {loadingPage} = this.props.status;
    const {isLoading, list} = this.props.profileState
    // console.log('====================================');
    // console.log({ list });
    // console.log('====================================');
    return (
      (loadingPage || isLoading) ? <Loading/> : list && (
        <div>
          <div className='row'>
            <div className='col-md-4' style={{ padding:'0px 25px'}}>
              <CardProfil data={list} />
            </div>
            <div className='col-md-8' style={{ padding:'0px 25px'}}>
              <CardData dataDetail={list} statusBtn={statusBtn} changeBtn={this.changeBtn} setFromParam={this.setFromParam}/>
            </div>
          </div>
        </div>
      )
    );
  }
}

const mapStateToProps = state => {
	return {
    loan : state.loanState,
    profileState : state.profileState //isLoading
	}
}

const mapDispatchToProps = dispatch =>{
    return {
		GetProfile : ClientID => {
			dispatch(ProfilAction(ClientID))
    },
    SetError: (err) => {
      dispatch({ type: SET_ERROR_STATE, payload : err })
    },
	}
}

// export default Profil;
// export default CheckAuth(Profil);
export default CheckAuth(connect(mapStateToProps, mapDispatchToProps)(Profil));